// extracted by extract-css-chunks-webpack-plugin
module.exports = {"news_box":"news_box-ZzIjStM7 clearfix","box_r":"box_r-37g8IMVn","d_box":"d_box-3vDbtWY7"};